import Link from 'next/link';
 import Icon from'@/components/ui/AppIcon';

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const quickLinks = [
    { id: 'footer_home', label: 'Home', href: '/homepage' },
    { id: 'footer_about', label: 'About', href: '/about' },
    { id: 'footer_models', label: 'Models & Pricing', href: '/models-pricing' },
    { id: 'footer_quote', label: 'Get a Quote', href: '/get-a-quote' },
    { id: 'footer_appointment', label: 'Book Appointment', href: '/book-appointment' },
    { id: 'footer_contact', label: 'Contact', href: '/contact' },
  ]

  const socialLinks = [
    { id: 'social_facebook', name: 'Facebook', icon: 'ShareIcon', href: 'https://www.facebook.com/profile.php?id=61584468262381' },
    { id: 'social_instagram', name: 'Instagram', icon: 'PhotoIcon', href: '#' },
    { id: 'social_linkedin', name: 'LinkedIn', icon: 'BriefcaseIcon', href: '#' },
  ]

  return (
    <footer className="bg-gray-900 text-gray-300 border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <Icon name="CubeIcon" size={24} className="text-primary-foreground" />
              </div>
              <span className="text-xl font-bold font-montserrat text-white">
                Take A Zip
              </span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Custom container solutions built for business. Premium quality, turn-key delivery, nationwide service.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <nav className="flex flex-col space-y-3">
              {quickLinks.map((link) => (
                <Link
                  key={link.id}
                  href={link.href}
                  className="text-sm hover:text-primary transition-colors"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <div className="flex flex-col space-y-3">
              <a
                href="https://wa.me/18634409462"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm hover:text-primary transition-colors"
              >
                <Icon name="ChatBubbleLeftRightIcon" size={18} />
                <span>863-440-9462 (WhatsApp only)</span>
              </a>
              <a
                href="mailto:sales@containersbytakeazip.com"
                className="flex items-center gap-2 text-sm hover:text-primary transition-colors"
              >
                <Icon name="EnvelopeIcon" size={18} />
                <span>sales@containersbytakeazip.com</span>
              </a>
              <a
                href="https://wa.me/18634409462"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-sm text-success hover:text-success/80 transition-colors"
              >
                <Icon name="ChatBubbleLeftRightIcon" size={18} />
                <span>WhatsApp Us</span>
              </a>
              <div className="flex items-center gap-2 text-sm">
                <Icon name="MapPinIcon" size={18} />
                <span>Florida, USA</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-500">
            © {currentYear} Containers by Take A Zip. All Rights Reserved.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.id}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-primary transition-colors"
                aria-label={social.name}
              >
                <Icon name={social.icon as any} size={20} />
              </a>
            ))}
          </div>

          <div className="flex items-center gap-4 text-sm text-gray-500">
            <Link href="#" className="hover:text-primary transition-colors">
              Privacy
            </Link>
            <span>·</span>
            <Link href="#" className="hover:text-primary transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer